import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'
import { rem } from '@mantine/core'

export const StyledSpotlightsBadgeIcon = styled.div`
  width: ${rem(24)};
  height: ${rem(24)};
  position: relative;
  .inner {
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.primaryBase};
    opacity: 0.1;
    border-radius: 50%;
  }
  &:before {
    content: '';
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background-color: ${theme.colors.primaryBase};
    opacity: 0.2;
  }
  &:after {
    content: '';
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 25%;
    height: 25%;
    border-radius: 50%;
    background-color: ${theme.colors.primaryBase};
  }
`

export const StyledSpotlightsItem = styled.div`
  min-width: ${rem(240)};
  border-radius: ${rem(8)};
`
